import { useEffect, useState } from 'react'
import './CreateNewRequisition.scss'
import { Card, Col, Label, Row, ReactSelectBox, Accordion, PrimaryButton, Tooltip } from '../../../../CommonComponents';
import ProductionVehicle from './ProductionVehicle';
import ManagementVehicle from './ManagementVehicle';
import ManagedEquipment from './ManagedEquipment';
import NonStandardEquipment from './NonStandardEquipment';
import { CONSTANTS } from '../../../../utils/constants'
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import { v4 as uuid } from 'uuid';

const CreateNewRequisition = (props: any) => {

  const branchTypeDropdownList = props.branchTypeDropdownList;
  const branchValue = props.branchValue;
  const branchOnChange = props.branchOnChange;
  const requisitionTypeDropdownList = props.requisitionTypeDropdownList;
  const requisitionType = props.requisitionType;
  const requisitionTypeOnChange = props.requisitionTypeOnChange;
  const hideDialog = props.hideDialog;
  const Popupcontent = props.Popupcontent;
  const popupOutlinebtnOnclick = props.popupOutlinebtnOnclick;
  const popupPrimarybtnOnclick = props.popupPrimarybtnOnclick;
  const isEditOrder = props.isEditOrder;
  const onAddItemClick = props.onAddItemClick;
  const selectRequisitionType = props.selectRequisitionType;
  const isRequisitiontypeSelected = props.isRequisitiontypeSelected;
  const isAddItemClick = props?.isAddItemClick;
  const orderByIdValue = props?.orderByIdValue;
  const isCostCenterAvailableForSubmit = props?.isCostCenterAvailableForSubmit
  const unique_id = uuid();

  const selectedRequisitionType = () => {
    if (requisitionType?.label === CONSTANTS.PRODUCTION_VEHICLE) {
      return <ProductionVehicle setItemDetailComponent={props.setItemDetailComponent} mobile={props.mobile} uniqueRefreshUUid={unique_id}/>
    }
    else if (requisitionType?.label === CONSTANTS.MANAGEMENT_VEHICLE) {
      return <ManagementVehicle setItemDetailComponent={props.setItemDetailComponent} mobile={props.mobile} uniqueRefreshUUid={unique_id}/>
    }
    else if (requisitionType?.label === CONSTANTS.MANAGED_EQUIPMENT) {
      return <ManagedEquipment setShowCatalog={props.setShowCatalog} setItemDetailComponent={props.setItemDetailComponent} mobile={props.mobile} uniqueRefreshUUid={unique_id} />
    }
    else if (requisitionType?.label === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      return <NonStandardEquipment setItemDetailComponent={props.setItemDetailComponent} mobile={props.mobile} uniqueRefreshUUid={unique_id}/>
    }
  }

  const [expandedItems, setExpandedItems] = useState<any>([]);
  const changeRequstionType = (requisitionType:any) =>{
    const items = [
      {
        headerText: (
          <>
            <p className="accordion-heading">{requisitionType?.label?.toUpperCase()}</p>
            <p className="subText mb-0">Select your Vehicle Type</p>
          </>
        ),
        content: (
          <>
            {selectedRequisitionType()}
          </>
        ),
        uuid: "VehicleType",
      },
    ];
    setExpandedItems(items);
  }
  useEffect(() => {
    changeRequstionType(requisitionType);
  }, [requisitionType])

  return (<>
    <Card data-attribute="CreateNewRequisition_Default_Card_2">
      <Row>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-md-0 mb-2'>
          <p className='headingText mb-0'>CREATE NEW REQUISITION</p>
          <p className='subText'>Select below option to create new requisition</p>
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
          {isEditOrder ?
            <>
            <p className='flexDisplay'>
              <p className='createdText'> Created By - </p>
              <Tooltip content = {orderByIdValue?.requestedBy ? orderByIdValue?.requestedBy : "-"} data-attribute="CreateNewRequisition_Default_Tooltip_3">
              <p className='createdContent'>{orderByIdValue?.requestedBy ? orderByIdValue?.requestedBy : "-"}</p>
              </Tooltip>
              </p>
            </>            
            : null}
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-md-0 mb-2'>
        <div>
            <Label required data-attribute="CreateNewRequisition_Default_Label_6">Requisition Type</Label>
            <ReactSelectBox
              options={requisitionTypeDropdownList}
              onChange={(item: any, e: any) => requisitionTypeOnChange(e, item)}
              name={selectRequisitionType.value}
              value={selectRequisitionType}
              className={selectRequisitionType?.value == "Select Requisition Type" ? 'controlValidation' : "" }
              selectRef={props.fieldRef}
             data-attribute="CreateNewRequisition_value_SearchSelectBox" />
            {(selectRequisitionType?.value == "Select Requisition Type" || (!isRequisitiontypeSelected && isAddItemClick)) ? <p className='validMessage'>Please Select the Requisition Type</p> : "" }
          </div>
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>        
          <div>
            <Label data-attribute="CreateNewRequisition_Default_Label_2_2">Branch</Label>
            <ReactSelectBox
              options={branchTypeDropdownList}
              onChange={(item: any, e: any) => branchOnChange(e, item)}
              value={branchValue}
              defaultValue = {branchValue}
              name={branchValue?.text}
              isDisabled = {isEditOrder ? true : false}
              isSearchable = {true}
             data-attribute="CreateNewRequisition_Default_SearchSelectBox_4" />
            {!isCostCenterAvailableForSubmit  ? <p className="branch-error"><b>Note:</b> Branch is not available in your location, please save if available.</p> : null}
          </div>
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='add-item-btn'>
          <PrimaryButton
            text='Add'
            onClick={()=>{onAddItemClick();changeRequstionType(requisitionType);}}
           data-attribute="CreateNewRequisition_Default_Button_2" />
        </Col>
      </Row>
    </Card>

    {
      (branchValue?.label && requisitionType?.value != "Select Requisition Type" && requisitionType?.value != undefined) ?
        <div className='vehicleTypeAccord'>
          <Card data-attribute="CreateNewRequisition_Default_Card_2_2">
            <Accordion
              Items={expandedItems}
              preExpanded={["VehicleType"]}
              allowZeroExpanded
              className="custom-accordion"
             data-attribute="CreateNewRequisition_Default_Accordion" />
          </Card>
        </div> : null
    }

    {Popupcontent.isDialogVisible ? 
    <CancelConfirmationPopup
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={() => popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => popupPrimarybtnOnclick()}
      /> : ""
    }

  </>
  )
};

export default CreateNewRequisition;
